import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../routes/createPathParameter';
import { notFoundResponse, okResponse } from '../../routes/defaultResponses';
import { makeNullable } from '../../utils/typeboxHelpers';
import { surveyScopeEntityTypeSchema, surveyScopeExclusionTableSchema } from './surveyScopeExclusionTableSchema';

const scopeItemSchema = Type.Object({
    entityType: surveyScopeEntityTypeSchema,
    entityId: Type.String({ format: 'uuid' }),
});

const getScopeResponseSchema = Type.Object({
    surveyId: Type.String({ format: 'uuid' }),
    definedScope: makeNullable(Type.String()),
    exclusions: Type.Array(surveyScopeExclusionTableSchema),
});

const putScopeBodySchema = Type.Object({
    definedScope: makeNullable(Type.String()),
    exclusions: Type.Array(scopeItemSchema),
});

const toggleScopeBodySchema = Type.Object({
    entityType: surveyScopeEntityTypeSchema,
    entityId: Type.String({ format: 'uuid' }),
    isInScope: Type.Boolean(),
});

export const surveyScopeExclusionPaths = {
    '/api/surveys/{surveyId}/scope': {
        get: {
            operationId: 'surveyScopeControllers.getScope',
            parameters: [createPathGuidParameter('surveyId')],
            responses: {
                '200': {
                    description: 'Scope (exclusions + free-text definedScope)',
                    content: { 'application/json': { schema: getScopeResponseSchema } },
                },
                ...notFoundResponse,
            },
        },
        put: {
            operationId: 'surveyScopeControllers.putScope',
            parameters: [createPathGuidParameter('surveyId')],
            requestBody: {
                content: { 'application/json': { schema: putScopeBodySchema } },
                required: true,
            },
            responses: {
                ...okResponse,
                ...notFoundResponse,
            },
        },
    },
    '/api/surveys/{surveyId}/scope/toggle': {
        patch: {
            operationId: 'surveyScopeControllers.toggleScope',
            parameters: [createPathGuidParameter('surveyId')],
            requestBody: {
                content: { 'application/json': { schema: toggleScopeBodySchema } },
                required: true,
            },
            responses: {
                ...okResponse,
                ...notFoundResponse,
            },
        },
    },
} as const;
